import { Base, base } from "./base"

export type GridTemplateColumns = Base

export const gridTemplateColumns: GridTemplateColumns = {
  ...base,
}
